'use client';
import { factory, Video, Box, DsmColor, OptionalPortal, FocusTrap } from '@kohler-dsm-library/kohler-core';
import { PlayIcon } from '@kohler-dsm-library/kohler-icons';
import React, { useState } from 'react';
import { OverlayVideo } from '../../../../Heroes/FullBleedHeroVideo/subcomponents/OverlayVideo/OverlayVideo.mjs';

const VideoCard = factory((props, ref) => {
  const { video, closeCTA } = props;
  const [openVideo, setOpenVideo] = useState(false);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Video, { ref, ...video, controls: false, position: "absolute", inset: "0" }), /* @__PURE__ */ React.createElement(
    Box,
    {
      position: "absolute",
      inset: "0",
      component: "button",
      type: "button",
      top: "50%",
      left: "50%",
      style: { transform: "translate(-50%, -50%)" },
      onClick: () => setOpenVideo(true)
    },
    /* @__PURE__ */ React.createElement(PlayIcon, { color: DsmColor.ContentOnPhoto, withBoundingBox: true, size: "medium" })
  ), openVideo && video && !video.autoPlay && /* @__PURE__ */ React.createElement(OptionalPortal, { target: ".kohler-two-up-content-root" }, /* @__PURE__ */ React.createElement(FocusTrap, null, /* @__PURE__ */ React.createElement(
    OverlayVideo,
    {
      zIndex: 105,
      ...video,
      autoPlay: true,
      muted: false,
      closeCTA: {
        onClick: (e) => {
          setOpenVideo(false);
          closeCTA?.onClick?.(e);
        }
      }
    }
  ))));
});

export { VideoCard };
